// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__nn8dw","ss01":"styles_ss01__IjrnP","ss02":"styles_ss02__3mewa","imageInColumn":"styles_imageInColumn__tVDyK"};